import $ from 'domtastic';
import { Starred } from './Starred';
import listViewMessage from './markup/listViewMessage';
import { cookie } from '../utils';

// Used for List Views to display error message if the product isn't found
class ListView {
  // Get clean city name
  static getCityName(slug) {
    switch (slug) {
      case 'orebro':
        return 'Örebro';

      case 'eskilstuna':
        return 'Eskilstuna';

      case 'vasteras':
        return 'Västerås';

      default:
        return undefined;
    }
  }

  static findObjects(storeArray, pageSubCategory) {
    const relevantObjects = {};
    storeArray.forEach((entry) => {
      // Check if city already has been found for the category, else push it
      if (entry.subcategory === pageSubCategory && !relevantObjects[entry.city]) {
        const cityName = ListView.getCityName(entry.city);
        if (cityName) {
          relevantObjects[cityName] = {
            name: cityName,
            slug: entry.city,
          };
        }
      }
    });

    return relevantObjects;
  }

  constructor() {
    this.cacheDom();
    if (!this.$message[0]) return;
    this.bindEvents();
    this.main();
  }

  cacheDom() {
    this.$message = $('.js-list-view-message');
  }

  bindEvents() {
    this.$message.on('click', '.js-list-view-link', (event) => {
      event.preventDefault();
      const $target = $(event.target);
      const value = $target.data('city');
      if (!value) return;
      cookie.set('city', value);
      location.reload();
    });
  }

  main() {
    const storeObject = Starred.getPreviousStarred();
    if (!storeObject) return this.showError();
    const storeArray = Object.values(storeObject);

    const pageSubCategory = this.$message.data('subcategory');
    if (!pageSubCategory) return this.showError();

    const relevantObjects = ListView.findObjects(storeArray, pageSubCategory);
    return this.showError(relevantObjects);
  }

  showError(relevantObjects) {
    const $markup = listViewMessage.create(relevantObjects, cookie.get('city'));
    this.$message.append($markup);
  }
}

export default new ListView();



// WEBPACK FOOTER //
// ./components/ListView.js